module.exports = __webpack_public_path__ + "static/0006-22e4fb2faead0b0794b082250237410a.png";